import FormImageUploader from 'components/FormImageUploader/FormImageUploader';
import {
	CreateDishContext,
	ICreateDishContext,
} from 'modules/Menu/Dishes/CreateDish/createDishState/createDishContext';
import React, { useContext } from 'react';
import InputFields from './InputFields/InputFields';
import classNames from 'classnames';
import style from './CreationForm.module.scss';

const descriptionOfAspectRatio = {
	horizontal: {
		ratio: '95:46',
		optimalResolutions: {
			a: '380*184px',
			b: '760*368px',
		},
	},
	vertical: {
		ratio: '44:19',
		optimalResolutions: {
			a: '528*228px',
			b: '1056*456px',
		},
	},
};

interface ICreationForm {
	isVisible: boolean;
}

const CreationForm: React.FC<ICreationForm> = ({ isVisible }) => {
	const { setFileId, fileId } = useContext<ICreateDishContext>(CreateDishContext);

	const containerClasses = classNames(style.container, { [style.visible]: isVisible });

	const deletePhotoHandler = () => {
		setFileId(null);
	};

	return (
		<div className={containerClasses} data-test="CreationForm">
			<FormImageUploader
				containerClass={style.imageUploader}
				maxFileSizeMB={1}
				fileId={fileId}
				setFileId={setFileId}
				deletePhotoHandler={deletePhotoHandler}
				horizontalAspectRatio={380 / 184}
				verticalAspectRatio={528 / 228}
				descriptionOfAspectRatio={descriptionOfAspectRatio}
			/>
			<InputFields />
		</div>
	);
};

export default CreationForm;
